import { useLocation } from '@gatsbyjs/reach-router';
import type { WrapPageElementBrowserArgs } from 'gatsby';
import React, { type ReactElement, useLayoutEffect } from 'react';

import { Header } from '../components/Header/Header';
import { SnackbarAlertsPortal } from '../components/SnackbarAlertsPortal/SnackbarAlertsPortal';
import { STATE_CHANGE_EVENT } from '../constants';

/**
 * Dispatch an event on app state render.
 */
function useLocationChange(): void {
  const location = useLocation();

  useLayoutEffect(() => {
    if (window) {
      const event = new CustomEvent(STATE_CHANGE_EVENT, { detail: { location } });

      window.dispatchEvent(event);
    }
  }, [location]);
}

/**
 * Add header to every page rendered.
 * Provide contexts required.
 */
function WrapPageElement({ element, props }: WrapPageElementBrowserArgs): ReactElement {
  useLocationChange();

  return (
    <>
      <Header {...props} />

      {element}

      <SnackbarAlertsPortal />
    </>
  );
}

// to follow Gatsby's API and keep eslint rules regarding hook names happy
export const wrapPageElement = WrapPageElement;
